import {
  type AutoApprover,
  EscalationApprovalRule,
} from "@p0security/shared/types/policy/types";
import { Select } from "@p0security/ui";
import {
  StyledFormItem,
  standardFormItemCols,
} from "components/common/forms/styles";
import { useAutoSelectSingleOption } from "hooks/useAutoSelectSingleOption";
import { useCallback, useMemo } from "react";

import { IncidentioScheduleSelect } from "./IncidentioScheduleSelect.tsx";

const labels: Record<AutoApprover, string> = {
  "grafana-irm": "Grafana IRM",
  incidentio: "Incident.io",
  pagerduty: "PagerDuty",
};

export const EscalationApproval: React.FC<{
  value: EscalationApprovalRule;
  installed: AutoApprover[];
  onChange: (rule: EscalationApprovalRule) => void;
}> = ({ installed, value, onChange }) => {
  const services = useMemo(() => value.services ?? [], [value]);

  const onUpdate = useCallback(
    (selected: string[]) => {
      onChange({ ...value, services: selected });
    },
    [onChange, value]
  );

  const installedOptions = useMemo(
    () => installed.map((key) => ({ value: key, label: labels[key] })),
    [installed]
  );

  const handleSelectApprover = useCallback(
    (integration: AutoApprover) => {
      onChange({ type: "escalation", integration, services: [] });
    },
    [onChange]
  );

  const { locked: integrationLocked } = useAutoSelectSingleOption(
    installedOptions,
    value.integration,
    handleSelectApprover
  );

  return (
    <>
      <StyledFormItem {...standardFormItemCols} label="Integration">
        <Select<AutoApprover>
          className={integrationLocked ? "auto-locked-select" : undefined}
          options={installedOptions}
          onSelect={handleSelectApprover}
          value={value.integration}
          disabled={integrationLocked}
        />
      </StyledFormItem>
      <IncidentioScheduleSelect
        integration={value.integration}
        services={services}
        onChange={onUpdate}
      />
    </>
  );
};
